import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { SequentialOrderActionsService } from "./sequential-order-actions.service";
import { filter, take, takeUntil } from "rxjs/operators";
import { AbstractControl, FormArray, FormGroup } from "@angular/forms";
import {
  SequentialOrderAction,
  SequentialOrderActionForm,
} from "./sequential-order-actions-model";
import {
  CONFIRM_DIALOG_CONFIRM_ACTION,
  CONFIRM_DIALOG_FORM_DUPL_NAME,
} from "../../locale/consts.en";
import { DatabaseService } from "../shared/database.service";
import {
  ConfDialogType,
  ConfirmDialogModel,
} from "../shared/confirm-dialog/confim-dialog.model";
import { ConfirmDialogComponent } from "../shared/confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "app-sequential-order-actions",
    templateUrl: "./sequential-order-actions.component.html",
    styleUrls: ["./sequential-order-actions.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SequentialOrderActionsComponent implements OnInit, OnDestroy {
  dialog = inject(MatDialog);
  private databaseService = inject(DatabaseService);
  private sequentialOrdActService = inject(SequentialOrderActionsService);

  private destroyed$ = new Subject();
  editMode: boolean | null = null;
  editing = false;
  formId: number | null = null;
  loadedSeqForms$: Observable<SequentialOrderAction[]>;
  file: unknown;
  form = new FormGroup(
    new SequentialOrderActionForm(new SequentialOrderAction())
  );

  constructor() {
    const sequentialOrdActService = this.sequentialOrdActService;

    this.loadedSeqForms$ = sequentialOrdActService.orderSequentialActions$;
  }

  ngOnInit(): void {
    this.getSeqOrderActions();
    this.sequentialOrdActService.ordActionsForm$
      .pipe(
        takeUntil(this.destroyed$),
        filter((val) => val !== undefined && val !== null)
      )
      .subscribe((seqAction: FormGroup) => {
        this.form = seqAction;
      });
  }

  getSeqOrderActions() {
    this.sequentialOrdActService.getAll();
  }

  createSeqForm() {
    this.editMode = false;
  }

  editSeqForm() {
    this.editMode = true;
  }

  getFormId(id: number) {
    if (id !== null) {
      this.formId = id;
    }
  }

  loadForm(i: number) {
    if (i !== null) {
      this.sequentialOrdActService.formInflate(i);
      this.formId = null;
      this.editing = true;
    }
  }

  clearRefresh() {
    this.editMode = null;
    this.formId = null;
    this.editing = false;
    this.sequentialOrdActService.orderActionClear();
    this.getSeqOrderActions();
  }

  deleteField(nr: number) {
    this.sequentialOrdActService.deleteField(nr);
  }

  addField() {
    this.sequentialOrdActService.addField();
  }

  getFormArray(fields: AbstractControl): FormArray {
    return fields as FormArray;
  }

  getFormGroup(item: AbstractControl) {
    return item as FormGroup;
  }

  saveSeqAction() {
    this.sequentialOrdActService.orderSequentialActions$
      .pipe(take(1))
      .subscribe((seqActions) => {
        const seqOrdAct = this.form.value as SequentialOrderAction;
        const index = seqActions.findIndex(
          (f) =>
            f.renderTag.trim().toLowerCase() ===
            this.form.controls.renderTag.value.trim().toLowerCase()
        );
        if (index !== -1) {
          const dialogData = new ConfirmDialogModel(
            CONFIRM_DIALOG_CONFIRM_ACTION,
            CONFIRM_DIALOG_FORM_DUPL_NAME,
            ConfDialogType.CONFIRM
          );

          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            maxWidth: "400px",
            data: dialogData,
          });

          dialogRef.afterClosed().subscribe((data) => {
            if (data) {
              this.saveAction(seqOrdAct);
            }
          });
        } else {
          /// new action - clear uuid
          seqOrdAct.uuid = null;
          this.saveAction(seqOrdAct);
        }
      });
  }

  private saveAction(seqOrdAct: SequentialOrderAction) {
    seqOrdAct.permissions = {};
    if (!!seqOrdAct.fields && seqOrdAct.fields.length > 1) {
      seqOrdAct.fields.sort((a, b) =>
        a.sort > b.sort ? 1 : b.sort > a.sort ? -1 : 0
      );
    }
    this.saveActionToApi(seqOrdAct);
    console.log("Action saved!", seqOrdAct);
  }

  saveActionToApi(seqAct: SequentialOrderAction) {
    this.sequentialOrdActService
      .addSeqAction(seqAct)
      .pipe()
      .subscribe({
        next: (response) => {
          if (response.status === 200 || response.status === 201) {
            console.log("Save OK!");
          } else {
            console.log("Save ERROR!");
          }
          this.clearRefresh();
        },
        error: () => this.databaseService.savingErrorMessage(),
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(1);
    this.destroyed$.complete();
  }
}
